export function EmptyState({ icon: Icon, title, description }) {
  return (
    <div className="flex flex-col items-center justify-center my-12 md:my-24 text-center">
      <div className='max-w-sm w-full items-center justify-center flex flex-col'>
        <div className="mb-4">
          <Icon />
        </div>
        <h2 className="text-2xl font-semibold text-white mb-2">{title}</h2>
        <p className="text-zinc-400">{description}</p>
      </div>
    </div>
  );
}